var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInPreparation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "222.000000pt",
    height: "195.000000pt",
    viewBox: "0 0 222.000000 195.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,195.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370 1870 c0 -37 4 -50 13 -47 7 2 12 21 12 47 0 26 -5 45 -12 48 -9 2 -13 -11 -13 -48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 1870 c-9 -15 35 -54 47 -42 12 12 4 28 -22 42 -12 6 -21 7 -25 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 1856 c-16 -17 -19 -26 -11 -31 17 -10 57 32 44 45 -7 7 -17 3 -33 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 1768 c2 -8 21 -13 47 -13 26 0 45 5 48 13 2 8 -11 12 -48 12 -37 0 -50 -4 -47 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 1768 c2 -8 20 -13 42 -13 22 0 40 5 43 13 2 8 -10 12 -43 12 -33 0 -45 -4 -42 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339 1761 c-20 -16 -22 -23 -14 -47 11 -32 55 -45 81 -23 21 17 18 66 -5 79 -27 14 -35 13 -62 -9z m59 -34 c2 -9 -4 -20 -12 -23 -21 -8 -46 13 -39 32 8 20 47 13 51 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 1696 c-16 -17 -19 -26 -11 -31 17 -10 57 32 44 45 -7 7 -17 3 -33 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377 1714 c-4 -4 -7 -27 -7 -51 0 -56 24 -54 28 2 3 37 -8 62 -21 49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440 1695 c0 -19 36 -39 45 -25 8 13 -13 40 -31 40 -8 0 -14 -7 -14 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143 1680 c-90 -55 -80 -185 19 -233 117 -57 237 89 162 197 -38 55 -122 72 -181 36z m135 -35 c85 -71 13 -204 -93 -174 -42 12 -75 53 -75 92 1 92 100 140 168 82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160 1620 c-21 -21 -27 -50 -11 -50 5 0 12 9 16 19 3 11 15 23 26 26 10 4 17 11 14 16 -9 14 -23 11 -45 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150 1530 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624 1418 c-24 -11 -44 -48 -44 -78 0 -10 11 -31 24 -46 50 -58 140 -24 140 52 0 63 -63 100 -120 72z m70 -31 c36 -27 14 -97 -31 -97 -20 0 -53 37 -53 59 0 20 34 51 55 51 6 0 19 -6 29 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675 1338 c-4 -10 -4 -26 0 -35 8 -17 8 -17 12 0 3 9 3 25 0 35 -4 16 -4 16 -12 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1632 1299 c2 -7 10 -15 17 -17 8 -3 12 1 9 9 -2 7 -10 15 -17 17 -8 3 -12 -1 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715 1299 c-4 -6 -5 -13 -2 -16 7 -7 27 6 27 18 0 12 -17 12 -25 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605 1260 c-8 -13 20 -24 41 -16 20 8 9 26 -16 26 -10 0 -22 -5 -25 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1717 1264 c-14 -14 -7 -25 13 -22 12 2 21 8 21 13 0 12 -24 18 -34 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1635 1219 c-4 -6 -5 -13 -2 -16 7 -7 27 6 27 18 0 12 -17 12 -25 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1670 1205 c0 -14 5 -25 10 -25 6 0 10 11 10 25 0 14 -4 25 -10 25 -5 0 -10 -11 -10 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1712 1219 c2 -7 10 -15 17 -17 8 -3 12 1 9 9 -2 7 -10 15 -17 17 -8 3 -12 -1 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 1105 c-14 -8 -32 -28 -39 -45 -22 -54 -1 -83 122 -162 99 -64 108 -73 109 -101 0 -18 2 -124 3 -237 3 -155 8 -218 20 -257 21 -66 91 -145 154 -173 44 -20 48 -25 44 -51 -2 -17 3 -40 12 -54 l16 -25 605 0 605 0 16 25 c10 15 14 37 12 55 -4 26 -1 31 28 40 48 16 129 93 156 148 22 44 23 61 28 297 l5 250 118 78 c122 80 144 107 132 155 -9 36 -50 72 -82 72 -15 0 -57 -18 -93 -40 -36 -22 -68 -40 -72 -40 -4 0 -8 17 -10 38 l-3 37 -840 0 -840 0 -3 -32 c-2 -18 -7 -33 -11 -33 -5 0 -35 16 -67 35 -63 38 -85 42 -125 20z m134 -80 c63 -43 67 -48 67 -83 0 -64 -8 -64 -105 2 -90 61 -107 84 -85 111 21 25 52 17 123 -30z m1717 -295 c0 -207 -4 -359 -11 -390 -14 -67 -62 -128 -129 -165 l-55 -30 -610 0 -610 0 -45 24 c-55 29 -81 51 -74 62 3 5 79 9 170 9 152 0 165 1 162 17 -3 16 -21 18 -189 21 l-186 2 -11 26 c-7 14 -12 34 -12 44 0 18 9 20 128 22 119 3 127 4 127 23 0 19 -8 20 -132 23 l-133 3 0 44 0 45 64 0 c45 0 65 4 69 14 9 24 -15 36 -75 36 l-58 0 0 255 0 255 805 0 805 0 0 -340z m240 325 c24 -29 2 -59 -87 -115 -115 -72 -115 -72 -111 -13 3 47 4 49 73 95 73 50 104 58 125 33z m-462 -984 c8 -51 10 -51 -581 -51 -359 0 -555 4 -568 10 -18 10 -26 50 -12 63 3 4 266 6 582 5 l576 -3 3 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765 270 c-8 -14 3 -30 21 -30 8 0 14 9 14 20 0 21 -24 28 -35 10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInPreparation);
export default __webpack_public_path__ + "static/media/InPreparation.d9695c61f87f00d2fd82e347cf1320cc.svg";
export { ForwardRef as ReactComponent };